export enum components {
  badge = '#badge2',
}
